import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { observer } from 'mobx-react'
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import ModalForm from '../../../../comum/components/ModalForm';
import LoadingImage from '../../../../comum/components/LoadingImage';

@observer
export default class ModalArmazenamento extends Component {
    
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }
    
    render() {
        return (
            <ModalForm
                esconderSalvar={true}
                className="modal-detalhes-orcamento"
                labelCancelar="FECHAR"
                onClickCancelar={this.controller.fecharModalArmazenamento}
            >
                <h2>
                    Detalhes de armazenagem
                </h2>
                {
                    this.controller.loadingDadosArmazenagem
                    ?<LoadingImage />
                    :<div>
                        <ToolkitProvider
                            keyField="Periodo"
                            data={[...this.controller.dadosArmazem.ArmCalcItemList]}
                            columns={this.controller.colunasDetalhesArmazenagem}
                        >
                            {props => <div className="tabela-detalhes">
                                <div className="tabela-detalhes__conteudo">
                                    <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        classes="tabela tabela-layout"
                                        {...props.baseProps}
                                    />
                                </div>
                                </div>
                            }
                        </ToolkitProvider>
                        <Row className="info-rodape mt-1 pt-2" style={{marginRight:"12px", marginLeft:"-2px"}}>
                            <Col>
                                <div>
                                    <div className="label">
                                        QTD.
                                    </div>
                                    <div>
                                        {this.controller.dadosArmazem && this.controller.dadosArmazem.ArmCalcItemList && this.controller.dadosArmazem.ArmCalcItemList.length}
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <div className="label">
                                        DIAS
                                    </div>
                                    <div>
                                        {this.controller.getTotalDemonstrativo("Dias")}
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <div className="label">
                                        CALCULADO
                                    </div>
                                    <div>
                                        {this.controller.getTotalDemonstrativo("ValorCalculado")}
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <div className="label">
                                        VALOR FINAL
                                        {console.log(this.controller.dadosArmazem)}
                                    </div>
                                    <div>
                                        {this.controller.dadosArmazem && !isNaN(parseFloat(this.controller.dadosArmazem.ArmCalc.ValorFinal)) && this.controller.dadosArmazem.ArmCalc.ValorFinal.toLocaleString('pt-BR',{style:'currency', currency:'BRL', minimumFractionDigits:2})}
                                    </div>

                                </div>
                            </Col>
                            <Col>
                                <div className="float-right">
                                    <div className="label">
                                        ADICIONAIS
                                    </div>
                                    <div>
                                        {this.controller.getTotalDemonstrativo("ValorAdicional")}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        </div>
                }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/importacao/components/ModalArmazenamento.js